import { IAppState } from '../common/state';

export const selectFirstGaLabel = (state: IAppState): string => state.results.offers[0]?.gaLabel || '';
